<script setup lang="ts">
import ManagementTeam from '~/domains/investor/corporate-governance/components/ManagementTeam/ManagementTeam.vue'
import { useFetchBoard } from '@/domains/investor/composables/useFetchBoard'

const { fetchBoard } = await useFetchBoard()
const response = await fetchBoard('coporate_governance_managment_board')
const presidentResponse = await fetchBoard('coporate_governance_president_board')
const managementTeam = response.data.value
const presidentTeam = presidentResponse.data.value
const locale = useI18n()

</script>

<template>
  <div class="managementTeamWrapper">
    <ManagementTeam
      :id="$t('investor.corporateGovernance.main.hero.firstButton.url').replace('#', '')"
      :key="locale"
      path-key-to-url="for-investors-corporate-governance-management-board-member"
      v-bind="presidentTeam"
    />

    <ManagementTeam
      :key="locale"
      has-divider
      path-key-to-url="for-investors-corporate-governance-management-board-member"
      v-bind="managementTeam"
    />
  </div>
</template>
